import { IconConfig, IconResourceType } from '@spartacus/storefront';

export enum CUSTOM_ICON_TYPE {
  ARROW_EXPAND = 'ARROW_EXPAND',
  ARROW_NAVIGATE = 'ARROW_NAVIGATE',
  ARROW_SLIDE = 'ARROW_SLIDE',
  BAR = 'BAR',
  CARD_PLUS = 'CARD_PLUS',
  CAR = 'CAR',
  CARD = 'CARD',
  CHAT = 'CHAT',
  CHAT_ROUND = 'CHAT_ROUND',
  CHECK = 'CHECK',
  CHECKBOX_CHECKMARK = 'CHECKBOX_CHECKMARK',
  CHECK_CIRCLE = 'CHECK_CIRCLE',
  CLOCK = 'CLOCK',
  CLOSE = 'CLOSE',
  CLOSE_ROUND = 'CLOSE_ROUND',
  COMPARISON = 'COMPARISON',
  COMPARISON_LISTING = 'COMPARISON_LISTING',
  COMPARISON_LISTING_ACTIVE = 'COMPARISON_LISTING_ACTIVE',
  CREDIT_CARD = 'CREDIT_CARD',
  DOWNLOAD = 'DOWNLOAD',
  ELLIPSIS = 'ELLIPSIS',
  EXCLAMATION_POINT = 'EXCLAMATION_POINT',
  EYE = 'EYE',
  EYE_CROSS_OUT = 'EYE_CROSS_OUT',
  FACEBOOK = 'FACEBOOK',
  FILE = 'FILE',
  FILTER = 'FILTER',
  HEADER_CART = 'HEADER_CART',
  HEADER_PHONE = 'HEADER_PHONE',
  HEART = 'HEART',
  HEART_FILL = 'HEART_FILL',
  HEART_LISTING = 'HEART_LISTING',
  HEART_LISTING_ACTIVE = 'HEART_LISTING_ACTIVE',
  INFO = 'INFO',
  INSTAGRAM = 'INSTAGRAM',
  LOCATION = 'LOCATION',
  LOCATION_WARNING = 'LOCATION_WARNING',
  LORRY = 'LORRY',
  MINUS = 'MINUS',
  MOBILE_RUBRICATOR = 'MOBILE_RUBRICATOR',
  ODNOKLASSNIKI = 'ODNOKLASSNIKI',
  PERSON = 'PERSON',
  PLUS = 'PLUS',
  POINT = 'POINT',
  RETURN = 'RETURN',
  RUBLE = 'RUBLE',
  RADIO_CHECKMARK = 'RADIO_CHECKMARK',
  RADIO_CIRCLE = 'RADIO_CIRCLE',
  SEARCH = 'SEARCH',
  SHOP = 'SHOP',
  SBP = 'SBP',
  SORT = 'SORT',
  SPINNER = 'SPINNER',
  STAR = 'STAR',
  TRASHBIN = 'TRASHBIN',
  USER = 'USER',
  WORK_TIME = 'WORK_TIME',
  CATALOG = 'CATALOG',
  BASKET = 'BASKET',
  FAVORITE = 'FAVORITE',
  MENU = 'MENU',
  PROFILE = 'PROFILE',
  WHATSAPP = 'WHATSAPP',
  WHATSAPPBW = 'WHATSAPPBW',
  TG = 'TG',
  COPY = 'COPY',
  SHARE = 'SHARE',
  PROMO = 'PROMO',
  QR = 'QR',
  PLAIT = 'PLAIT',
}

export const iconConfig: IconConfig = {
  icon: {
    symbols: {
      ARROW_EXPAND: 'arrow-expand',
      ARROW_NAVIGATE: 'arrow-navigate',
      ARROW_SLIDE: 'arrow-slide',
      BAR: 'bar',
      CARD_PLUS: 'card-plus',
      CAR: 'car',
      CARD: 'card',
      CHAT: 'chat',
      CHAT_ROUND: 'chat-round',
      CHECK: 'check',
      CHECKBOX_CHECKMARK: 'checkbox-checkmark',
      CHECK_CIRCLE: 'check-circle',
      CLOCK: 'clock',
      CLOSE: 'close',
      CLOSE_ROUND: 'close-round',
      COMPARISON: 'comparison',
      COMPARISON_LISTING: 'comparison-listing',
      COMPARISON_LISTING_ACTIVE: 'comparison-listing-active',
      CREDIT_CARD: 'credit-card',
      DOWNLOAD: 'download',
      ELLIPSIS: 'ellipsis',
      EXCLAMATION_POINT: 'exclamation-point',
      EYE: 'eye',
      EYE_CROSS_OUT: 'eye-cross-out',
      FACEBOOK: 'facebook',
      FILE: 'file',
      FILTER: 'filter',
      HEADER_CART: 'header-cart',
      HEADER_PHONE: 'header-phone',
      HEART: 'heart',
      HEART_FILL: 'heart-fill',
      HEART_LISTING: 'heart-listing',
      HEART_LISTING_ACTIVE: 'heart-listing-active',
      INFO: 'info',
      INSTAGRAM: 'instagram',
      LOCATION: 'location',
      LOCATION_WARNING: 'location-warning',
      LORRY: 'lorry',
      MINUS: 'minus',
      MOBILE_RUBRICATOR: 'mobile-rubricator',
      ODNOKLASSNIKI: 'odnoklassniki',
      PERSON: 'person',
      PLUS: 'plus',
      POINT: 'point',
      RETURN: 'return',
      RUBLE: 'ruble',
      RADIO_CHECKMARK: 'radio-checkmark',
      RADIO_CIRCLE: 'radio-circle',
      SEARCH: 'search',
      SHOP: 'shop',
      SBP: 'sbp',
      SORT: 'sort',
      SPINNER: 'spinner',
      STAR: 'star',
      TRASHBIN: 'trashbin',
      USER: 'user',
      WORK_TIME: 'work-time',
      CATALOG: 'catalog',
      BASKET: 'basket',
      FAVORITE: 'favorite',
      MENU: 'menu',
      PROFILE: 'profile',
      WHATSAPP: 'whatsapp',
      WHATSAPPBW: 'whatsapp-bw',
      TG: 'tg',
      COPY: 'copy',
      SHARE: 'share',
      PROMO: 'promo',
      QR: 'qr',
      PLAIT: 'plait',
    },
    resources: [
      {
        type: IconResourceType.SVG,
        url: require('apps/sdvor/src/assets/sprite.svg'),
        types: Object.keys(CUSTOM_ICON_TYPE),
      },
    ],
  },
};
